module.exports = __webpack_public_path__ + "img/calendarHomeIcon.e5c08dd6.svg";